import { useParams, Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import PageMeta from '@/components/feature/PageMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import NotFound from '@/pages/NotFound';

const comments = [
  {
    id: 'c1',
    author: '热心吃瓜群众',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20abstract%20avatar%20with%20warm%20amber%20circle%20on%20dark%20background%2C%20minimalist%20design%2C%20clean%20aesthetic%2C%20professional%20look%2C%20plain%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
    content: '这瓜保熟吗？看了聊天记录感觉真是一言难尽，人设这种东西真的太脆弱了。建议大家都来看看原视频，别被带节奏。',
    time: '2026-07-06 15:30',
    likes: 3200,
  },
  {
    id: 'c2',
    author: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20abstract%20avatar%20with%20dark%20crimson%20circle%20on%20warm%20background%2C%20minimalist%20design%2C%20clean%20aesthetic%2C%20professional%20look%2C%20plain%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    content: '我看完了全部视频，说实话反转太大了。之前还一直关注她，觉得是个阳光正能量的博主，没想到私下完全是另一个人。',
    time: '2026-07-06 14:20',
    likes: 1800,
  },
  {
    id: 'c3',
    author: '理性分析员',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20abstract%20avatar%20with%20muted%20gold%20circle%20on%20dark%20background%2C%20minimalist%20design%2C%20clean%20aesthetic%2C%20professional%20look%2C%20plain%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    content: '其实这种事情在网红圈太常见了，只是大多数没有被曝光而已。吃瓜还是要理性，不要网暴，让事实说话。',
    time: '2026-07-06 12:45',
    likes: 4200,
  },
];

function generateArticleContent(title: string, category: string): string {
  const paragraphs = [
    `<p>近日，一则关于<strong>${title.slice(0, 15)}</strong>的消息在社交媒体上引发热议。据知情人士透露，该事件涉及多个圈内人士，目前已有大量证据浮出水面。</p>`,
    `<p>根据爆料者提供的材料显示，此次事件并非偶然，而是长期积累的结果。从最初的蛛丝马迹到如今的大面积曝光，整个过程持续了数月之久。</p>`,
    `<h3>事件的来龙去脉</h3>`,
    `<p>据了解，事情的起因可以追溯到今年年初。当时就有部分细心的粉丝发现了一些端倪，但由于缺乏实质性证据，并未引起广泛关注。随着时间推移，越来越多的线索被逐一挖掘出来，最终形成了完整的证据链。</p>`,
    `<p>一位不愿透露姓名的业内人士向<strong>吃瓜爆料网</strong>表示："这种情况在圈内其实并不少见，但能像这样被完整曝光出来的确实不多。主要是因为涉及的当事人粉丝量太大，一旦曝光必然会引起轩然大波。"</p>`,
    `<h3>各方反应</h3>`,
    `<p>事件曝光后，当事人在其社交平台上发布了简短的回应声明，称"正在核实相关情况，将尽快给出明确答复"。但这份声明并未平息舆论，反而引发了更多讨论。</p>`,
    `<p>多位同领域的博主也纷纷发声。其中一位拥有五百万粉丝的头部博主表示："作为同行，我对此感到非常震惊。希望公众能保持理性，等待更多事实浮出水面。"</p>`,
    `<p>与此同时，相关品牌的反应也十分迅速。据<strong>吃瓜爆料网</strong>了解，已有至少三家合作品牌宣布暂停与该网红的合作关系，并表示将"密切关注事态发展"。</p>`,
    `<h3>粉丝反应两极化</h3>`,
    `<p>在各大社交平台上，粉丝的反应呈现出明显的两极化趋势。一部分忠实粉丝坚决站在博主一边，认为这是"恶意抹黑"和"有组织的黑公关行为"；而另一部分粉丝则表达了深深的失望，表示"无法接受这样的人设崩塌"。</p>`,
    `<p>一位自称关注该博主三年的老粉丝在评论区写道："真的很难过，从她只有几千粉的时候就开始关注，看着她一步步走到今天。如果这些爆料都是真的，那种被欺骗的感觉真的很难形容。"</p>`,
    `<h3>行业影响</h3>`,
    `<p>此次事件对整个<strong>${category}</strong>领域产生了深远的影响。多位行业观察人士指出，这可能会引发一轮行业洗牌，推动更多规范和监管措施的出台。</p>`,
    `<p>有分析认为，随着短视频和直播行业的快速发展，网红经济的泡沫也在逐渐被戳破。粉丝对真实性的需求越来越高，任何虚假人设最终都难以长久维持。</p>`,
    `<h3>总结</h3>`,
    `<p>截至发稿时，该事件仍在持续发酵中。<strong>吃瓜爆料网</strong>将持续关注事件进展，为读者带来第一手的最新报道。在此也提醒广大网友，吃瓜需理性，不传谣不信谣，以官方发布的最终信息为准。</p>`,
  ];
  return paragraphs.join('\n');
}

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const article = articles.find((a) => a.id === id);

  if (!article) {
    return <NotFound />;
  }

  const relatedArticles = articles
    .filter((a) => a.id !== article.id && (a.categorySlug === article.categorySlug || a.isHot))
    .slice(0, 3);

  const articleContent = generateArticleContent(article.title, article.category);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Article',
        '@id': `http://91flj.cn/article/${id}#article`,
        headline: article.title,
        description: article.excerpt,
        author: { '@type': 'Person', name: article.author },
        datePublished: article.publishDate,
        image: article.coverImage,
        publisher: { '@type': 'Organization', name: '吃瓜爆料网', '@id': 'http://91flj.cn/#organization' },
        mainEntityOfPage: { '@type': 'WebPage', '@id': `http://91flj.cn/article/${id}` },
        articleSection: article.category,
        wordCount: 800,
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'http://91flj.cn/' },
          { '@type': 'ListItem', position: 2, name: article.category, item: `http://91flj.cn/category/${article.categorySlug}` },
          { '@type': 'ListItem', position: 3, name: article.title },
        ],
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '这篇文章可信度如何？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '吃瓜爆料网始终坚持真实、客观的报道原则，所有爆料内容均经过多方位核实后发布。本文信息来源于多方渠道交叉验证，确保内容可靠。',
            },
          },
          {
            '@type': 'Question',
            name: '如何获取更多类似爆料内容？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '您可以访问吃瓜爆料网首页浏览更多分类内容，或下载吃瓜爆料网APP开启推送通知，第一时间获取最新网红塌房和黑料大瓜爆料。',
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <PageMeta
        title={`${article.title} - 吃瓜爆料网`}
        description={article.excerpt}
        keywords={`吃瓜爆料网, ${article.tags.join(', ')}, 网红塌房, 黑料大瓜, 每日爆料`}
        canonicalUrl={`http://91flj.cn/article/${id}`}
        ogImage={article.coverImage}
        ogType="article"
        jsonLd={jsonLd}
      />

      <main>
        <Navbar />

        {/* 文章头部 */}
        <article className="w-full bg-background-50 pt-24 md:pt-28 pb-8">
          <div className="px-4 md:px-6">
            {/* 面包屑 */}
            <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6 flex-wrap" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
              <i className="ri-arrow-right-s-line text-foreground-400" />
              <Link to={`/category/${article.categorySlug}`} className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                {article.category}
              </Link>
              <i className="ri-arrow-right-s-line text-foreground-400" />
              <span className="text-foreground-700 line-clamp-1">{article.title}</span>
            </nav>

            <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16">
              <div className="w-full lg:w-[40%]">
                <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full mb-4">
                  {article.category}
                </span>
                <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-extrabold text-foreground-950 leading-tight mb-4">
                  {article.title}
                </h1>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                  {article.excerpt}
                </p>
                <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-500 mb-6">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line" />
                    {article.author}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line" />
                    {article.publishDate}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {(article.readCount / 10000).toFixed(1)}万 阅读
                  </span>
                </div>
                <div className="flex flex-wrap gap-2">
                  {article.tags.map((tag) => (
                    <span key={tag} className="px-3 py-1 bg-secondary-100 text-secondary-700 text-xs rounded-full">
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>
              <div className="w-full lg:w-[60%]">
                <div className="rounded-2xl overflow-hidden aspect-[16/9]">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover"
                    title={article.title}
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* 文章正文 */}
        <section className="w-full bg-background-50 pb-8">
          <div className="px-4 md:px-6 max-w-3xl mx-auto">
            <div
              className="prose prose-lg max-w-none text-foreground-800 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: articleContent }}
            />
          </div>
        </section>

        {/* 评论区 */}
        <section className="w-full bg-background-100 py-14 md:py-20">
          <div className="px-4 md:px-6 max-w-3xl mx-auto">
            <div className="text-center mb-10">
              <span className="text-xs font-semibold tracking-widest uppercase text-secondary-500">精选评论</span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-1">
                网友热议
              </h2>
            </div>

            <div className="space-y-6">
              {comments.map((comment) => (
                <div key={comment.id} className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/70">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-secondary-200">
                      <img
                        src={comment.avatar}
                        alt={comment.author}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between mb-2">
                        <div>
                          <span className="text-sm font-semibold text-foreground-950">{comment.author}</span>
                          <span className="text-xs text-foreground-500 ml-2">{comment.time}</span>
                        </div>
                        <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                          <i className="ri-thumb-up-line" />
                          {comment.likes}
                        </span>
                      </div>
                      <p className="text-sm text-foreground-700 leading-relaxed">
                        {comment.content}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 相关推荐 */}
        {relatedArticles.length > 0 && (
          <section className="w-full bg-background-50 py-14 md:py-20">
            <div className="px-4 md:px-6">
              <div className="mb-10">
                <span className="text-xs font-semibold tracking-widest uppercase text-secondary-500">RELATED</span>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-1">
                  相关爆料推荐
                </h2>
                <p className="text-sm text-foreground-600 mt-2">
                  更多精彩爆料内容，继续吃瓜不停歇
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {relatedArticles.map((ra, index) => (
                  <Link
                    key={ra.id}
                    to={`/article/${ra.id}`}
                    className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
                  >
                    <div className={`relative aspect-[16/10] overflow-hidden ${index === 0 ? 'bg-primary-100' : 'bg-secondary-100'}`}>
                      <img
                        src={ra.coverImage}
                        alt={ra.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        title={ra.title}
                        loading="lazy"
                      />
                      <div className="absolute top-3 left-3">
                        <span className="inline-block px-2 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-full">
                          {ra.category}
                        </span>
                      </div>
                    </div>
                    <div className="flex flex-col flex-1 p-4 md:p-5">
                      <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors duration-200">
                        {ra.title}
                      </h3>
                      <p className="text-xs text-foreground-600 line-clamp-2 mb-4 leading-relaxed flex-1">
                        {ra.excerpt}
                      </p>
                      <div className="flex items-center justify-between text-xs text-foreground-500 mb-4">
                        <span className="flex items-center gap-1">
                          <i className="ri-eye-line" />
                          {(ra.readCount / 10000).toFixed(1)}万
                        </span>
                        <span>{ra.publishDate}</span>
                      </div>
                      <span className={`whitespace-nowrap block text-center w-full py-2.5 rounded-full text-sm font-semibold transition-all duration-200 ${
                        index === 0
                          ? 'bg-primary-500 text-background-50 group-hover:bg-primary-600'
                          : 'bg-transparent border border-foreground-300 text-foreground-700 group-hover:border-primary-300 group-hover:text-primary-500'
                      }`}>
                        阅读全文
                      </span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* APP下载引导 */}
        <section className="w-full bg-background-100 py-14 md:py-20">
          <div className="px-4 md:px-6">
            <div className="max-w-2xl mx-auto text-center">
              <div className="rounded-2xl overflow-hidden aspect-[16/9] mb-12">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20entertainment%20news%20app%20with%20breaking%20gossip%20feed%2C%20warm%20amber%20and%20dark%20moody%20background%2C%20cinematic%20lighting%2C%20premium%20app%20mockup%2C%20editorial%20photography&width=1200&height=675&seq=app-download-article-cta&orientation=landscape"
                  alt="下载吃瓜爆料网APP解锁完整内容"
                  className="w-full h-full object-cover"
                  title="吃瓜爆料网APP下载"
                  loading="lazy"
                />
              </div>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3 leading-tight">
                解锁<span className="italic font-normal text-secondary-400 mx-1">完整爆料</span>内容
              </h2>
              <p className="text-sm text-foreground-600 mb-10 leading-relaxed">
                下载吃瓜爆料网APP，第一时间获取更多网红塌房、黑料大瓜完整视频和聊天记录
              </p>
              <Link
                to="/about"
                className="whitespace-nowrap inline-flex items-center gap-2 px-10 py-4 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-download-2-line text-lg" />
                立即下载APP
              </Link>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}